
// CadastrarApagar.js

import React, { useState, useEffect } from 'react';
import TipoField from './TipoField';
import CodigoField from './CodigoField';
import DatepickerField from './DatepickerField';
import ModalPesquisarCliente from './ModalPesquisarCliente'; 
import Box from '@mui/material/Box';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import '../App.css';


function CadastrarApagar({ venda, handleSaveClick, handleCancelaClick }) {

  const [formData, setFormData] = useState({
    codvenda: '',
    dtvenda: '',
    tipo: '',
    nomecli: '',
    codcli: '',
    cnpjcli: '',
    empresa: '',
    codemp: '',
    cnpjemp: '',
    idcliente: ''  // Estado para armazenar dados do cliente selecionado
  }); 

  const [pesquisarCliente, setPesquisarCliente] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchUltimoCodVenda = async () => {
      try {
        const response = await api.get('/ultimoCodVenda');
        if (response.data !== null && response.data !== undefined) {
          const novoCodVenda = response.data + 1;
          setFormData(prevFormData => ({
            ...prevFormData,
            codvenda: novoCodVenda
          }));
        }
      } catch (error) {
        console.error('Erro ao obter o último código da venda:', error);
      }
    };

    fetchUltimoCodVenda();
  }, []);

  useEffect(() => {
    // Recuperar os dados da empresa do localStorage
    const storedEmpresa = localStorage.getItem('selectedEmpresaDetails');
    if (storedEmpresa) {
      const empresaDetails = JSON.parse(storedEmpresa);
      setFormData(prevFormData => ({
        ...prevFormData,
        empresa: empresaDetails.empresa,
        codemp: empresaDetails.codemp,
        cnpjemp: empresaDetails.cnpjemp
      }));
    }
  }, []);


  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };
  

  //Função  para  Salvar a Nova Venda
  const handleSaveVenda = async () => {
    if (isSaving) {
      return;
    }

    const mandatoryFields = ['nomecli', 'cnpjcli'];
    const hasErrors = mandatoryFields.some(field => {
      const value = formData[field];
      console.log(`Campo ${field}:`, value);
      return typeof value !== 'string' || value.trim() === '';
   });

    if (hasErrors) {
      alert('O Código da Venda e a Seleção do Cliente são obrigatórios.');
      return;
    }

    // Formatar os dados da Venda antes de enviar para o backend
    const dataToSend = {
      ...formData,
      cliente: { id: formData.idcliente }, // Enviando o ID do cliente
    };

    setIsSaving(true);
    try {
      const response = await api.post('/cadastrarvenda', dataToSend);
      console.log('Venda criada com sucesso:', response.data);
      window.alert(`Venda: ${dataToSend.codvenda} Cadastrada com Sucesso.`);

      handleSaveClick(response.data.venda);

    } catch (error) {
      console.error('Erro ao criar Venda:', error.response ? error.response.data : error.message);
    } finally {
      setIsSaving(false);
    }
  };
  
  const getDataAtualISO = () => {
    const data = new Date();
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0'); 
    const ano = data.getFullYear();
    return `${ano}-${mes}-${dia}`;
  };

  if (!formData.dtvenda.trim()) {
    formData.dtvenda = getDataAtualISO();
  }

  const handleClienteSelecionado = (cliente) => {
    setFormData({
      ...formData,
      idcliente: cliente.id, // Captura o ID do cliente selecionado
      nomecli: cliente.nomecli,
      codcli: cliente.codcli,
      cnpjcli: cliente.cnpjcli,
    });
    setPesquisarCliente(false);
  };

  const handleOpenModalPesquisaCliente = () => {
    setPesquisarCliente(true);
  };

  const handleCloseModalPesquisaCliente = () => {
    setPesquisarCliente(false);
  };


  return (
    <div style={{ minHeight: 'calc(100vh - 20px)', maxWidth: '900px', paddingTop: '10px', margin: '0 auto', textAlign: 'center' }}>
      <div style={{ marginBottom: '20px' }}>
        <h3>Cadastrar Conta a Receber</h3>
      </div>
      <div style={{ textAlign: 'left', marginLeft: '20px' }}>
        <div style={{ display: 'flex', marginBottom: '20px' }}>
          <div style={{ width: '100px', marginRight: '20px' }}>
            <label>Venda:</label>
            <CodigoField value={formData.codvenda} onChange={value => handleChange('codvenda', value)} />
          </div>
          <div style={{ width: '120px' }}>
            <label>Data da Venda:</label>
            <DatepickerField value={formData.dtvenda} onChange={value => handleChange('dtvenda', value)} />
          </div>
          <div style={{ width: '160px', marginLeft: '20px' }}>
            <label>Tipo da Venda:</label>
            <TipoField value={formData.tipo} onChange={value => handleChange('tipo', value)} />
          </div>


          <div style={{ marginLeft: '20px' }}>
            <button onClick={handleOpenModalPesquisaCliente} style={{ width: '150px', marginTop: '20px', height: '30px' }}>Selecionar Cliente</button>
          </div>
        </div>

        <div style={{ display: 'flex', marginTop: '0px' }}>
          <div style={{ width: '420px', marginRight: '20px' }}>
            <label>Cliente:</label>
            <input type="text" value={formData.nomecli} onChange={e => handleChange('nomecli', e.target.value)} readOnly style={{ width: '420px', height: '30px' }} />
          </div>
          <div style={{ width: '100px' }}>
            <label>Cód. Cliente:</label>
            <input type="text" value={formData.codcli} onChange={e => handleChange('codcli', e.target.value)} readOnly style={{ width: '100px', height: '30px' }} />
          </div>
          <div style={{ width: '150px', marginLeft: '20px' }}>
            <label>CNPJ do Cliente:</label>
            <input type="text" value={formData.cnpjcli} onChange={e => handleChange('cnpjcli', e.target.value)} readOnly style={{ width: '150px', height: '30px' }} />
          </div>
        </div>

        <div style={{ display: 'flex', marginBottom: '20px' }}>
          <div style={{ width: '420px', marginRight: '20px' }}>
            <label>Empresa:</label>
            <input type="text" value={formData.empresa} onChange={e => handleChange('empresa', e.target.value)} style={{ width: '420px', height: '30px' }} />
          </div>

          <div style={{ width: '100px', marginTop: '0px' }}>
            <label style={{ display: 'block', width: '100px', marginTop: '0px' }}>Cód Empresa</label>
            <input type="text" value={formData.codemp} onChange={e => handleChange('codemp', e.target.value)} readOnly style={{ width: '100px', height: '30px' }} />
          </div>            
          <div style={{ width: '150px', marginTop: '0px' }}>
            <label style={{ display: 'block', width: '150px', marginTop: '0px', marginLeft: '20px' }}>CNPJ da Empresa</label>
            <input type="text" value={formData.cnpjemp} onChange={e => handleChange('cnpjemp', e.target.value)} readOnly style={{ width: '150px', marginLeft: '20px', marginTop: '0px', height: '30px' }} />
          </div>

        </div>
        
        </div>

    <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
        <button  type="button" className='btn-menu' onClick={handleSaveVenda} style={{ width: '100px', height: '30px', padding: '3px 5px', marginRight: '50px', color: 'inherit' }}>
          {isSaving ? 'Salvando...' : 'Salvar'}
        </button>
        <button type="button" className='btn-menu' onClick={handleCancelaClick}
          style={{ width: '100px', height: '30px', padding: '3px 5px', color: 'inherit' }}>Cancelar
        </button>
      </div>
    </Box>

      {pesquisarCliente && (
        <ModalPesquisarCliente
          isOpen={pesquisarCliente}
          onClose={handleCloseModalPesquisaCliente}
          onClienteSelecionado={handleClienteSelecionado}
        />
      )}

    </div>
  );
}

export default CadastrarApagar;